import React, {useState} from "react";
import {IUserEntity} from "@buildwitt/shapeshift-types";
import {makeStyles} from "tss-react/mui";
import {Box, Button, Typography} from "@mui/material";
import {Modal} from "@buildwitt/shapeshift-common/v1/modal";
import {AdminTable, AdminTableProps} from "@buildwitt/shapeshift-common/v2/admin";

export interface IProps {
	onClose: (ids?: number[]) => void,
	announcementId: number
}

const useStyles = makeStyles()(
	(_theme) => ({
		newLibraryImportModal: {
		},
		container: {
			display: "flex",
			gap: "40px",
			flexDirection: "column"
		},
		body: {},
		selectedCountFooter: {
			color: "grey",
			paddingRight: "15px",
			fontSize: "12px"
		},
		header: {
			display: "flex",
			justifyContent: "space-between !important"
		},
		title: {
			flexGrow: 2
		},
		fullScreen: {
			paddingRight: "20px",
			cursor: "pointer",
			"& span":{
				marginLeft: "10px"
			}
		}
	})
);

const headCells = (): AdminTableProps<"user", IUserEntity>["columns"] => ([
	{
		field: "firstname",
		type: "string",
		flex: 1,
		filterable: false,
		sortable: false,
		headerName: "First Name",
		width: 100
	},
	{
		field: "lastname",
		type: "date",
		flex: 1,
		filterable: false,
		sortable: false,
		headerName: "Last Name",
		width: 100,
	},
	{
		field: "jobTitle",
		type: "string",
		flex: 1,
		filterable: false,
		sortable: false,
		headerName: "Job Title",
	},
	{
		field: "startedAt",
		type: "string",
		flex: 1,
		filterable: false,
		sortable: false,
		headerName: "Started At",
		valueGetter: (e) => e.value ? new Date(e.value).toLocaleDateString() : ""
	},
	{
		field: "completedAt",
		type: "string",
		flex: 1,
		filterable: false,
		sortable: false,
		headerName: "Completed At",
		valueGetter: (e) => e.value ? new Date(e.value).toLocaleDateString() : ""
	}
]);

const AnnouncementSeenByListModal: React.FunctionComponent<IProps> = (props) => {
	const {classes} = useStyles();

	return (
		<Modal width={700} open={true} className={classes.newLibraryImportModal} onClose={() => props.onClose()} footerButtons={[
			<Button key="cancel" onClick={() => props.onClose()}>
				close
			</Button>
		]} >
			<Box className={classes.container}>
				<Box className={classes.header}>
					<Typography className={classes.title} variant="h5" id="title">
						Seen by
					</Typography>
				</Box>
				<Box className={classes.body}>
					<AdminTable<"user", IUserEntity>
						url={"/api/announcement/" + props.announcementId + "/seenBy"}
						columns={headCells()}
						type="user"
						disableColumnFilter
						keepNonExistentRowsSelected
					/>
				</Box>
			</Box>
		</Modal>
	);
};

export default AnnouncementSeenByListModal;
